import { createContext, ReactNode, useCallback, useEffect, useState } from "react";

interface interfThemeContext {
    theme: 'light' | 'dark';
    updateTheme: (theme: 'light' | 'dark') => void;
}
export const ThemeContext = createContext({} as interfThemeContext);

interface interfProps {
    children: ReactNode;
}

export function ThemeProvider(props: interfProps) {

    const [theme, setTheme] = useState<'light' | 'dark'>('light');

    useEffect(() => {

        let dataLSTheme: string | null = localStorage.getItem('@GovfacilGestor:theme');
        let localUserData: any = null;
        if (typeof dataLSTheme == 'string') {
            localUserData = JSON.parse(dataLSTheme);
        }

        if (localUserData) {
            setTheme(localUserData)
        } else {

            localStorage.setItem('@GovfacilGestor:theme', JSON.stringify('light'));

            setTheme('light');
            window.location.reload();
        }


    }, []);

    const updateTheme = useCallback((theme: 'light' | 'dark'): void => {

        localStorage.setItem('@GovfacilGestor:theme', JSON.stringify(theme));

        setTheme(theme);

    }, []);

    return (
        <ThemeContext.Provider value={{
            updateTheme, theme
        }}>
            {props.children}
        </ThemeContext.Provider>
    )
}
